import HTTP from '@/config/axios-config-erp'

const ServiceFechasRoles = {
  getRoles(payload) {
    return HTTP.post(`/wscomun/portalinformes/listaRoles`, payload).then(response => {
      return response
    })
  },
  actualizarRoles(payload) {
    return HTTP.post(`/wscomun/portalinformes/addFechaRol`, payload).then(response => {
      return response
    })
  },
  getRole(payload) {
    return HTTP.post(`/wscomun/portalinformes/rolePortal`, payload).then(response => {
      return response
    })
  },
  getFechasRoles(payload) {
    return HTTP.post(`/wscomun/portalinformes/getFechasRoles`, payload).then(response => {
      return response
    })
  }
}

export default ServiceFechasRoles



// WEBPACK FOOTER //
// ./src/services/srv-fechas-roles.js